var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#04B776",
    fillOpacity: 0.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 31V17C15.5 15.1144 15.5 14.1716 16.0858 13.5858C16.6716 13 17.6144 13 19.5 13H29.5C30.3317 13 30.9778 13 31.5037 13.0271C29.2519 13.2741 27.5 15.1825 27.5 17.5V21.0002L27.4012 30.9671L24.5 30L21.5 31L18.5 30L15.5 31ZM34.5 21L29.5 21V17.5C29.5 16.1193 30.6193 15 32 15C33.3807 15 34.5 16.1193 34.5 17.5V21ZM17.5 17C17.5 16.4477 17.9477 16 18.5 16H24.5C25.0523 16 25.5 16.4477 25.5 17C25.5 17.5523 25.0523 18 24.5 18H18.5C17.9477 18 17.5 17.5523 17.5 17ZM17.5 21C17.5 20.4477 17.9477 20 18.5 20H20.5C21.0523 20 21.5 20.4477 21.5 21C21.5 21.5523 21.0523 22 20.5 22H18.5C17.9477 22 17.5 21.5523 17.5 21ZM17.5 25C17.5 24.4477 17.9477 24 18.5 24H22.5C23.0523 24 23.5 24.4477 23.5 25C23.5 25.5523 23.0523 26 22.5 26H18.5C17.9477 26 17.5 25.5523 17.5 25Z",
    fill: "#04B776"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.fd339da634c88837097c83b62f12ba94.svg";
export { ForwardRef as ReactComponent };